<template>
  <div class="SelectList">
    <div class="bg-gray-200 tw-p-1">
      <FilterField @filter="onFilter"></FilterField>
    </div>
    <ul class="list" v-if="listExist">
      <ItemRenderer
        v-for="(item, index) in filteredList"
        v-if="item"
        :key="item.id + index"
        :item="item"
        :itemType="itemType"
        :messages="messages"
        :level="0"
        :isFiltered="isFiltering"
        @select="onSelect"
        @unselect="onUnselect"
      >
      </ItemRenderer>
    </ul>
    <div v-else class="text-center p-4">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">{{ $t("global.loading") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ItemRenderer from "@/components/ui/fields/SelectListItemRenderer";
import FilterField from "@/components/ui/Filter";
import Utils from "@/services/utils.js";

export default {
  name: "SelectList",
  components: {
    ItemRenderer,
    FilterField,
  },
  props: {
    list: {
      type: [Array, Object],
    },
    itemType: {
      type: String,
      default: "nom",
    },
    messages: {
      type: Object,
      default: function () {
        return {
          lock: {
            item: Utils.t("profile.form.tooltipDeviceDisabled"),
            folder: Utils.t("profile.form.tooltipGroupDisabled"),
          },
        };
      },
    },
    filterAttribute: {
      type: String,
      default: "name",
    },
  },
  methods: {
    onSelect: function (item) {
      this.$emit("select", item);
    },
    onUnselect: function (item) {
      this.$emit("unselect", item);
    },
    onFilter: function (value) {
      this.isFiltering = !!value;

      for (var item in this.filteredList) {
        if (this.filteredList[item].children != null) {
          for (var child in this.filteredList[item].children) {
            if (
              this.filteredList[item].children[child][this.filterAttribute]
                .toLowerCase()
                .indexOf(value.toLowerCase()) == -1
            ) {
              this.filteredList[item].children[child].filtered = true;
            } else {
              this.filteredList[item].children[child].filtered = false;
            }
          }
        } else {
          if (
            this.filteredList[item][this.filterAttribute]
              .toLowerCase()
              .indexOf(value.toLowerCase()) == -1
          ) {
            this.filteredList[item].filtered = true;
          } else {
            this.filteredList[item].filtered = false;
          }
        }
      }
    },
    initList: function () {
      this.filteredList = this.list;
      this.listExist = !!this.list[0];

      for (var iKey in this.filteredList) {
        if (this.filteredList[iKey].children != null) {
          for (var jKey in this.filteredList[iKey].children) {
            Vue.util.defineReactive(
              this.filteredList[iKey].children[jKey],
              "filtered",
              false
            );
          }
        }
        Vue.util.defineReactive(this.filteredList[iKey], "filtered", false);
      }
    },
  },
  mounted: function () {
    this.initList();
  },
  watch: {
    list: function () {
      this.initList();
    },
  },
  data: () => ({
    filteredList: [],
    listExist: false,
    isFiltering: false,
  }),
};
</script>

<style lang="scss">
$selectlist-height: 55px;

.SelectList {
  border: var(--input-border);

  .filter {
    border: var(--input-border);
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .folder,
  .item {
    border-top: var(--input-border);
    cursor: pointer;
    &.disabled {
      background-color: var(--colors-gray-100);
      cursor: not-allowed;
    }
  }
  .item-inner {
    min-height: $selectlist-height;
    font-size: var(--text-base);
  }
  .handler {
    cursor: pointer;
    text-align: center;
    transition-property: transform;
    width: 40px;
  }
  .show .handler {
    transform: rotate(90deg);
  }
  .wrapper {
    height: 0;
    overflow: hidden;
    transition-property: height;
  }
}
</style>
